import React from 'react'

class RateComp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false
        }
    }

    render() {
        const { handle, type, disabled, title, keys } = this.props
        let { rate } = this.props

        if ((rate || rate === 0) && (rate + '').slice(-1) != '.') {
            rate = Number(rate)
                .toFixed(9)
                .replace(/\.?0*$/, '')
        }

        return (
            <div style={{ display: 'flex' }}>
                <span style={{ ...styles.label }}>{title}</span>
                {this.state.edit ? (
                    <>
                        <input style={{ ...styles.input }} value={rate} onChange={e => handle(e, keys)} />
                        <div style={{ ...styles.sideBtn }} onClick={() => this.setState({ edit: false })}>
                            <span style={{ ...styles.close }}>{'x'}</span>
                        </div>
                    </>
                ) : disabled ? (
                    <span>{rate}</span>
                ) : (
                    <span style={{ ...styles.button }} onClick={() => this.setState({ edit: true })}>
                        {rate}
                    </span>
                )}
            </div>
        )
    }
}

const styles = {
    button: {
        cursor: 'pointer',
        padding: '2px 4px',
        boxShadow: '#d1d1d1 0px 0px 4px 1px',
        borderRadius: '2px'
    },
    sideBtn: {
        cursor: 'pointer',
        background: 'white',
        border: 'solid #d1d1d1 1px',
        borderRadius: '2px 0 0 2px',
        height: '25px',
        width: '14px',
        textAlign: 'center'
    },
    // close: {
    //     rotate: '45deg'
    // },
    input: {
        outline: 'none',
        border: 'solid #d1d1d1 1px',
        borderRadius: '0 2px 2px 0',
        width: '46px'
    },
    label: {
        margin: '0 0 0 5px'
    }
}

export default RateComp
